import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env } from '../../../environments/environment';
import { BehaviorSubject, Observable, first, map, tap, zip } from 'rxjs';
import { LgvLoanApp } from '../../data-models/lgv-loan-application.model';
/** JSON Loader Service
 * 
 * - __Json$ properties represent an object for one JSON file.
 * - Add a method to get the JSON file whenever we add a new one
 * - Include the new method in the zip array inside the initializeJsonConfigs() method 
 *      to make sure it is loaded upon app initialization
 * - Properties for each specific object should be done on the specific service and not here.
 *      example: Inside the loan-application.json file, we have the loanAppFields object. 
 *          The property for that should be placed in the loan-app.service.ts and not here. 
 *          This service will only contain JSON File related properties. 
 */
@Injectable({
    providedIn: 'root'
})
export class JsonLoaderService {
    isJsonConfigsReady$ = new BehaviorSubject(false);
    //Json File Subjects
    lendingPadLoanAppJson$ = new BehaviorSubject(null);
    meridianLinkLoanAppJson$ = new BehaviorSubject(null);
    loanAppTermsAndConditionsJson$ = new BehaviorSubject(null);
    shortAppJson$ = new BehaviorSubject(null);
    licensingTaskDetailsJson$ = new BehaviorSubject(null);

    constructor(private http: HttpClient) { }

    initializeJsonConfigs() {
        this.isJsonConfigsReady$.next(false);
        zip([
            this.getLendingPadLoanAppJson(),
            this.getLoanAppTermsAndConditionsJson(),
            this.getShortApplicationJson(),
            this.getMeridianLinkLoanAppJson(),
        ]).subscribe(() =>
            this.isJsonConfigsReady$.next(true))
    }


    //#region JSON get methods -- add a method per JSON File
    private getLendingPadLoanAppJson(): Observable<any> {
        return this.http.get<any>(env.jsonConfigs.formly.lendingPadLoanApp).pipe(
            first(),
            tap((loanApplication) => {
                return this.lendingPadLoanAppJson$.next(loanApplication);
            })
        );
    }

    private getMeridianLinkLoanAppJson(): Observable<any> {
        return this.http.get<any>(env.jsonConfigs.formly.meridianLinkLoanApp).pipe(
            first(),
            tap((loanApplication) => {
                return this.meridianLinkLoanAppJson$.next(loanApplication);
            })
        );
    }

    private getLoanAppTermsAndConditionsJson(): Observable<any> {
        return this.http.get<any>(env.jsonConfigs.loanAppTermsAndConditions).pipe(
            first(),
            tap((termsAndConditions) => this.loanAppTermsAndConditionsJson$.next(termsAndConditions))
        );
    }

    private getShortApplicationJson(): Observable<any> {
        return this.http.get<any>(env.jsonConfigs.formly.shortApplication).pipe(
            first(),
            tap((shortApplication) => {
                return this.shortAppJson$.next(shortApplication);
            })
        );
    }
    //#endregion
}
